module.exports = __webpack_public_path__ + "img/frances-willard.4aa66cc9.png";